<app-page-header title="Home" active_item="Indicadores" titleLink="/indicators"></app-page-header>

<app-metabase-public-embed
  [url]="
    'https://reports.harpiatechnology.io/public/dashboard/278f4999-49aa-498d-bc9c-6b77e6e1c831
'
  "
>
</app-metabase-public-embed>